// extracted by mini-css-extract-plugin
export default {"sharing":"styles-module--sharing--qkeyi"};